import React from "react";

export const AboutPage = () => {
   return (
      <div>Lorem ipsum dolor sit, amet consectetur adipisicing elit. Error ut nesciunt maxime reiciendis autem magni unde expedita. Ex, magni? Adipisci perferendis placeat quidem suscipit ut quasi non, ad, aut id assumenda vitae harum. Dolores quasi animi beatae repudiandae natus quis ipsa maiores commodi numquam, debitis, facere doloremque? Soluta, saepe suscipit.</div>
   )
}